import React, { useState } from 'react'
import "./media.scss"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

const Media = () => {
  const { t } = useTranslation()

  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const handleShow = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const images = [
    '/assets/alldetailpages/xprotocol/info/media/1.gif',
    '/assets/alldetailpages/xprotocol/info/media/2.png',
    '/assets/alldetailpages/xprotocol/info/media/3.png',
    '/assets/alldetailpages/xprotocol/info/media/4.png',
    '/assets/alldetailpages/xprotocol/info/media/5.png',
  ];

  return (
    <>
      <section className="media-section">
        <div className="first-para" style={{ margin: "0" }}>
          <h2>{t('Gems-detailt44')}<span></span></h2>
        </div>
        <div className="bottom-gallery">
          {images.map((image, index) => (
            <div className="single-gallery" key={index}>
              <img
                src={image}
                alt={`img-${index}`}
                className="img-fluid"
                onClick={() => handleShow(image)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
          {/* <div className="single-gallery">
            <img src="https://res.cloudinary.com/drt6vurtt/image/upload/v1702386642/dop/v1_sc9jyd.svg" alt="img" className='img-fluid' />
            <h6>Project Intro</h6>
            <p>20 Nov, 2023</p>
          </div>
          <div className="single-gallery">
            <img src="\assets\detail-page\dummy-gallery.svg" alt="img" className='img-fluid' />
            <h6>Project Intro</h6>
            <p>20 Nov, 2023</p>
          </div>
          <div className="single-gallery">
            <img src="\assets\detail-page\dummy-gallery.svg" alt="img" className='img-fluid' />
            <h6>Project Intro</h6>
            <p>20 Nov, 2023</p>
          </div>
          <div className="single-gallery">
            <img src="\assets\detail-page\dummy-gallery.svg" alt="img" className='img-fluid' />
            <h6>Project Intro</h6>
            <p>20 Nov, 2023</p>
          </div> */}
        </div>
      </section>

      <Modal className='common-modal-style image-preview' show={show} onHide={handleClose} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='p-0'>
          <img src={selectedImage} alt="Selected" className="img-fluid w-100" />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Media
